
import Vue from 'vue'
export default Vue.extend({
  functional: true,
  props: ['item'],
  render: function (h: any, ctx: any) {
    return h('span', 
      {
        class: ['v-chip', 'theme--light'],
      }, 
      [
        h('span', 
          {
            class: 'v-chip__content',
          },
          [
            ctx.props.item.name || ctx.props.item.brand,
            h('div', 
              {
                class: 'v-chip__close',
              },
              [
                h('i', 
                  {
                    class: ['v-icon', 'fas', 'fa-times-circle', 'theme--light'],
                    on: {
                      click: () => {
                        const listener = ctx.listeners['remove'];
                        if(listener) {
                          listener();
                        }
                      }
                    }
                  },
                  []
                )
              ]
            )
          ]
        )
      ]
    )
  }
})
